<script>
    import { Link } from "svelte-routing";
    </script>
   <nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom border-secondary">
		<div class="container-fluid">
		  <Link class="navbar-brand" to="/">	
<img class="img-fluid rounded-circle" width="40" src="https://1.bp.blogspot.com/-HviSDMYvDTM/YY9YL_2bTUI/AAAAAAAAR20/jFygs2BsNEAouM37FUqo6uRNRQA5pFssQCLcBGAsYHQ/s400/sveltes.png" alt="Svelte Unicentapos apps" /></Link>
		  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			<span class="navbar-toggler-icon"></span>
		  </button>
		  <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
			<ul class="navbar-nav p-1">
			<li class="nav-item"><Link class="nav-link" to="/">Home</Link></li>
			<li class="nav-item"><Link class="nav-link" to="/about">About</Link></li>
			<li class="nav-item"><Link class="nav-link" to="/cat">Categories</Link></li>
			<li class="nav-item"><Link class="nav-link" to="/cost">Cost</Link></li>
			<li class="nav-item"><Link class="nav-link" to="/price">Sell</Link></li>
			<li class="nav-item"><Link class="nav-link" to="/user">User</Link></li>
			<li class="nav-item"><Link class="nav-link" to="/cash">Cash Flow</Link></li>
			<li class="nav-item"><Link class="nav-link" to="/close">Close Cash</Link></li>
			<li class="nav-item"><a class="nav-link" href="https://www.hockeycomputindo.com/2021/11/how-to-install-unicenta-web-app-svelte.html">Documentation</a></li>
			<li class="nav-item"><a class="nav-link btn btn-dark text-white" href="https://github.com/mesinkasir/sveltekit-unicenta">Github</a></li>
		</ul>
	</div>
</div>
</nav>
  